import FlowPanel from './FlowPanel';

export default FlowPanel;
